import { GridColDef, GridInitialState } from "@mui/x-data-grid-premium";
import React from "react";
import useApi from "../../hooks/useGaneshApi";
import { renderPercentCell } from "utils/dataGrid";
import GaneshDataGrid from "../DataGrid/GaneshDataGrid";

import { useError } from "../../contexts/ErrorContext";
import { useQuery } from "@tanstack/react-query";

interface CustomerSchemaCoverageTableProps {
  customerId?: string;
}

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [{ field: "attribute", sort: "asc" }] },
  pagination: { paginationModel: { pageSize: 50, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "compact",
  aggregation: {},
};

const columns_def: GridColDef[] = [
  { field: "parent_key", headerName: "Parent Key", width: 250 },
  { field: "attribute", headerName: "Attribute", width: 250 },
  {
    field: "pct_coverage",
    headerName: "Pct Coverage",
    width: 200,
    type: "number",
    renderCell: renderPercentCell,
  },
];

const CustomerSchemaCoverageTable: React.FC<
  CustomerSchemaCoverageTableProps
> = ({ customerId }) => {
  const { showError } = useError();
  const { apiRequest } = useApi();

  const {
    data: customerSchemaCoverageData = [],
    isLoading,
    isError,
    error,
  } = useQuery<any[], Error>({
    queryKey: ["customerSchemaCoverage", customerId],
    queryFn: async () => {
      const response = await apiRequest<any[]>(
        `/v1/customers/${customerId}/schema_coverage`
      );
      if (response.error) {
        throw new Error(response.error);
      }
      return response.data || [];
    },
    enabled: !!customerId,
  });

  if (isError) {
    showError(
      `Failed to fetch customer schema coverage for ${customerId}: ${error.message}`
    );
  }

  return (
    <GaneshDataGrid
      loading={isLoading}
      data={customerSchemaCoverageData}
      columns={columns_def}
      gridId="customerSchemaCoverageGrid"
      defaultGridState={defaultGridState}
    />
  );
};

export default CustomerSchemaCoverageTable;
